
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoiceNumberFormatGrid extends Serenity.EntityGrid<InvoiceNumberFormatRow, any> {
        protected getColumnsKey() { return InvoiceNumberFormatColumns.columnsKey; }
        protected getDialogType() { return InvoiceNumberFormatDialog; }
        protected getIdProperty() { return InvoiceNumberFormatRow.idProperty; }
        protected getInsertPermission() { return InvoiceNumberFormatRow.insertPermission; }
        protected getLocalTextPrefix() { return InvoiceNumberFormatRow.localTextPrefix; }
        protected getService() { return InvoiceNumberFormatService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}